/**
 * Script frontend pour le bloc Sommaire automatique
 * Extrait automatiquement les titres H2-H6 du contenu et génère le sommaire
 */

document.addEventListener('DOMContentLoaded', function () {
    // Trouver tous les blocs sommaire automatique sur la page
    const tocBlocks = document.querySelectorAll('.wp-block-capmonetique-sommaire-automatique')

    if (tocBlocks.length === 0) {
        return
    }

    // Trouver le contenu du post
    const postContent = document.querySelector('.wp-block-post-content')

    if (!postContent) {
        console.warn('Sommaire automatique: Aucun contenu de post trouvé (.wp-block-post-content)')
        return
    }

    // Extraire les titres H2 du contenu
    const headings = extractHeadings(postContent)

    // Générer le sommaire pour chaque bloc
    tocBlocks.forEach((tocBlock) => {
        generateTOC(tocBlock, headings)
    })

    // Initialiser le scroll spy
    if (headings.length > 0) {
        initScrollSpy(headings)
    }
})

/**
 * Extrait les titres H2 du contenu et génère des slugs
 */
function extractHeadings(content) {
    const headings = []
    const headingElements = content.querySelectorAll('h2')

    headingElements.forEach((heading, index) => {
        const text = heading.textContent.trim()

        if (text) {
            // Générer un slug unique
            let slug = createSlug(text)

            // Assurer l'unicité du slug
            const existingSlugs = headings.map((h) => h.slug)
            let counter = 1
            let originalSlug = slug

            while (existingSlugs.includes(slug)) {
                slug = `${originalSlug}-${counter}`
                counter++
            }

            // Ajouter l'ID au titre si il n'en a pas déjà un
            if (!heading.id) {
                heading.id = slug
            }

            headings.push({
                level: 2,
                text: text,
                slug: heading.id || slug,
                element: heading,
            })
        }
    })

    return headings
}

/**
 * Crée un slug à partir d'un texte
 */
function createSlug(text) {
    return text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // Supprimer les accents
        .replace(/[^a-z0-9\s-]/g, '') // Garder seulement lettres, chiffres, espaces et tirets
        .trim()
        .replace(/\s+/g, '-') // Remplacer les espaces par des tirets
        .replace(/-+/g, '-') // Supprimer les tirets multiples
}

/**
 * Génère le HTML du sommaire et l'insère dans le bloc
 */
function generateTOC(tocBlock, headings) {
    const tocList = tocBlock.querySelector('.toc-list')

    if (!tocList) {
        return
    }

    // Vider la liste existante
    tocList.innerHTML = ''

    if (headings.length === 0) {
        tocList.innerHTML = '<li class="toc-no-headings">Aucun titre trouvé dans le contenu</li>'
        return
    }

    // Générer les éléments de liste
    headings.forEach((heading) => {
        const listItem = document.createElement('li')
        listItem.className = 'heading-h2'

        const link = document.createElement('a')
        link.href = `#${heading.slug}`
        link.textContent = heading.text
        link.addEventListener('click', function (e) {
            e.preventDefault()
            setActiveLink(link)
            scrollToHeading(heading.element)
        })

        listItem.appendChild(link)
        tocList.appendChild(listItem)
    })
}

/**
 * Scroll fluide vers un titre
 */
function scrollToHeading(element) {
    if (element) {
        // Détection dynamique du header fixe
        const header = document.querySelector('#site-header')
        const isHeaderFixed = header && header.classList.contains('fixed')

        // Offset adaptatif : 120px si header fixe, 24px sinon
        const offset = isHeaderFixed ? 120 : 24

        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
        const offsetPosition = elementPosition - offset

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        })
    }
}

/**
 * Active un lien du sommaire
 */
function setActiveLink(activeLink) {
    // Désactiver tous les liens
    const allLinks = document.querySelectorAll('.wp-block-capmonetique-sommaire-automatique .toc-list a')
    allLinks.forEach(link => link.classList.remove('active'))
    
    // Activer le lien cliqué
    activeLink.classList.add('active')
}

/**
 * Initialise le scroll spy pour activer automatiquement les liens
 */
function initScrollSpy(headings) {
    const links = document.querySelectorAll('.wp-block-capmonetique-sommaire-automatique .toc-list a')
    
    // Fonction pour déterminer quel heading est actuellement visible
    function updateActiveLink() {
        const viewportHeight = window.innerHeight
        const triggerPoint = viewportHeight / 2 // Milieu de l'écran
        
        let activeHeading = null
        
        // Parcourir les headings dans l'ordre inverse pour prioriser les sections plus hautes
        for (let i = headings.length - 1; i >= 0; i--) {
            const heading = headings[i]
            const element = heading.element
            const rect = element.getBoundingClientRect()
            
            // Si le heading est au-dessus ou au niveau du milieu de l'écran
            if (rect.top <= triggerPoint) {
                activeHeading = heading
                break // Prendre le premier (plus haut) qui respecte la condition
            }
        }
        
        // Si aucun heading n'est au-dessus du milieu, prendre le premier visible
        if (!activeHeading) {
            headings.forEach(heading => {
                const element = heading.element
                const rect = element.getBoundingClientRect()
                
                // Si le heading est visible dans la viewport
                if (rect.top >= 0 && rect.top <= viewportHeight && !activeHeading) {
                    activeHeading = heading
                }
            })
        }
        
        // Mettre à jour les liens actifs
        if (activeHeading) {
            links.forEach(link => {
                link.classList.remove('active')
                if (link.getAttribute('href') === `#${activeHeading.slug}`) {
                    link.classList.add('active')
                }
            })
        }
    }
    
    // Écouter le scroll avec throttling pour les performances
    let scrollTimeout
    window.addEventListener('scroll', function() {
        if (scrollTimeout) {
            clearTimeout(scrollTimeout)
        }
        scrollTimeout = setTimeout(updateActiveLink, 10)
    })
    
    // Initialiser l'état au chargement
    updateActiveLink()
}
